import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';
import { useIconMaskId } from './useIconMaskId';

export function IndexerIcon(props: ToolIconProps) {
  const maskId = useIconMaskId('indexer');

  return (
    <ToolIconFrame {...props}>
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="48">
          <rect width="48" height="48" fill="#fff" />
          <rect x="29" y="1" width="18" height="18" rx="2" fill="#000" />
        </mask>
      </defs>
      <g mask={`url(#${maskId})`}>
        <path
          d="M6.25 17c0-2.057 6.658-3.75 14.75-3.75S35.75 14.943 35.75 17 29.092 20.75 21 20.75 6.25 19.057 6.25 17m0 0v21c0 2.057 6.658 3.75 14.75 3.75S35.75 40.057 35.75 38V17M6.25 27.5c0 2.057 6.658 3.75 14.75 3.75s14.75-1.693 14.75-3.75"
          fill="none"
          stroke={toolIconPrimary}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M36.5 3h3v5h5v3h-5v5h-3v-5h-5V8h5z"
        fill={toolIconSecondary}
        stroke={toolIconSecondary}
        strokeWidth="1"
      />
    </ToolIconFrame>
  );
}
